import { useMemo } from 'react'
import { useQuery } from '@apollo/client/react'
import { useBusinessIdPathParam } from 'lib/navigation/hooks/useBusinessIdPathParam/useBusinessIdPathParam'
import { ProfileHookDocument } from 'lib/hooks/gql/useProfileHook.graphql'

export const useMembershipRole = () => {
  const businessId = useBusinessIdPathParam()
  const { data } = useQuery(ProfileHookDocument)

  return useMemo(() => {
    const membership = data?.profile?.membership

    // `membership` resolves against the business id header, which can lag the path param during a
    // business switch or on a stale URL. Callers read `undefined` as "not resolved yet", so a
    // mismatch must stay undefined rather than report another business's role.
    if (membership?.business?.id !== businessId) {
      return undefined
    }

    return membership.role
  }, [data?.profile?.membership, businessId])
}
